import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal } from '@repo/design-system/index'
import { n_classroom, s_classroom, s_evaluation } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { IMG_ZOOM_GUIDE_CLASSROOM_EN, IMG_ZOOM_GUIDE_CLASSROOM_KR } from '../../modules/images'
const ZoomGuideModalBody = ({
  lesson,
  onClose,
  setShowChatBox,
  showPopup,
  setShowPopup,
}: {
  lesson: any
  onClose: any
  setShowChatBox: any
  showPopup: boolean
  setShowPopup: any
}) => {
  const { t, isLocaleKO } = useTranslation()
  const url = lesson.join_url ?? ''
  const meeting_number: number = lesson.meeting_number ?? 0
  const handleClickRequestHelp = () => {
    // 팝업 닫고
    // 헬프챗 열기
    onClose()
    setShowChatBox(true)
  }
  return (
    <DSModal
      id="ContentsLGTwoButtonVerticalPopup"
      isOpen={showPopup}
      setIsOpen={setShowPopup}
      size="xl"
      closeButton
      closeOnDim={true}
    >
      <DSModal.Title>
        <div className="Headline2-24Bd">{t(n_classroom.popup_zoom_help_title)}</div>
      </DSModal.Title>
      <DSModal.Content>
        <div>
          <div className="Body1-16Bd">{t(s_classroom.modal_zoom_tap_2)}</div>
          <div className="Body2-14Md mt-[8px]">
            {t(s_classroom.modal_zoom_desc_2)}
            <div className="mt-[16px] flex flex-row items-center justify-between">
              <div>
                <DSButton
                  size={BUTTON_SIZE.SM}
                  type={BUTTON_TYPE.SOLID}
                  disabled={meeting_number === 0}
                  onClick={(e: React.MouseEvent<HTMLElement>) => {
                    const popup = window.open(url, '_blank')
                    if (!popup) {
                      console.info('zoom 강제실행 버튼 클릭 - 팝업안열림', lesson?.id)
                    }
                  }}
                >
                  <DSButton.Label>{t(s_classroom.btn)}</DSButton.Label>
                </DSButton>
              </div>
            </div>
          </div>
          <div className="Body1-16Bd mt-[24px] text-gray-700">{t(s_classroom.modal_zoom_tap_1)}</div>
          <div className="Body2-14Md mt-[8px] text-gray-700">{t(s_classroom.modal_zoom_desc_1)}</div>
          <div className="mt-[8px]">
            <img src={isLocaleKO ? IMG_ZOOM_GUIDE_CLASSROOM_KR : IMG_ZOOM_GUIDE_CLASSROOM_EN} alt="Zoom Guide" />
          </div>
          <div className="Body2-14Md mt-[16px] flex justify-center">
            {t(
              s_classroom.modal_zoom_desc_3(
                <span
                  className="cursor-pointer text-purple-500 underline underline-offset-2"
                  onClick={handleClickRequestHelp}
                >
                  {t(s_evaluation.help)}
                </span>
              )
            )}
          </div>
        </div>
      </DSModal.Content>
    </DSModal>
  )
}
export default ZoomGuideModalBody
